<mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
  <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
    <div class="mat-tree-node" style="display: flex; align-items: center" [ngClass]="{ loading: node.isLoading }">
      <button mat-icon-button matTreeNodeToggle>
        <mat-icon>
          {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
        </mat-icon>
      </button>
      <mat-icon class="mr-1">folder</mat-icon>
      {{ node.name }}
    </div>
    @if (treeControl.isExpanded(node)) {
      <ng-container matTreeNodeOutlet></ng-container>
    }
  </mat-nested-tree-node>

  <mat-tree-node *matTreeNodeDef="let node">
    <div
      class="mat-tree-node"
      style="display: flex; align-items: center"
      (click)="onNodeClick(node)"
      [ngClass]="{ loading: node.isLoading }"
    >
      <span style="width: 24px; display: inline-block"></span>
      <mat-radio-button [checked]="selectedCategory()?.id === node.id">
        {{ node.name }}
      </mat-radio-button>
    </div>
  </mat-tree-node>
</mat-tree>
